/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */


expocadfx.pageSetup = (function() {
	'use strict';
    var data = expocadfx.fxData;
    var config = expocadfx.config;
    var fxStyle = expocadfx.styles;
    var txt = expocadfx.txt;
    var elem = expocadfx.element;
    var elemById = elem.elementById;
    var util = expocadfx.util;
	var comparer = expocadfx.comparer;
	var setupFloorPlanToolbar = expocadfx.setupFloorPlanToolbar;
	var setupLanguageSelection = expocadfx.setupLanguageSelection;
	var setupMiniMap = expocadfx.setupMiniMap;
	var salesWindow = expocadfx.SalesWindow;
    
    var doc = document;
    var navList = doc.createElement( "ul");
	
	
	
	function setupExhibitorListHeader( btn) {
		var exhFilter = elemById( "exhibitorFilter");
		var textColor = (fxStyle.exhibitor.clrText !== "") ?
								fxStyle.exhibitor.clrText : fxStyle.mainHeader.clrText;
		
		elemById( "exhibitorListHeader").style.backgroundColor = (fxStyle.exhibitor.clrBg !== "") ?
													fxStyle.exhibitor.clrBg : fxStyle.mainHeader.clrBg;
		
		elemById( "exhibitorListHeader").style.color = textColor;
		
		if( config.hasMultipleViews && config.hasFloorPlan) {
			exhFilter.appendChild( elem.filterItem( "hall", txt.EXHIBITOR_FILTER_HALL, false));
		}
		exhFilter.appendChild( elem.filterItem( "all", txt.EXHIBITOR_FILTER_ALL, config.initialAllExhibitors));
		exhFilter.appendChild( elem.filterItem( "tag", txt.EXHIBITOR_FILTER_TAGGED, false));
		//   if needed - available booth option added from pgCtl
		
		elemById( "btnExhibitorListEmail").style.color = config.DISABLED_GRAY;
		elemById( "btnExhibitorListEmail").setAttribute( "title", txt.TT_EMAIL_TAGGED_BOOTHS);
			// won't work because color set in code!
//		util.addClass( elemById( "btnExhibitorListEmail"), "disabled");
		
		elemById( "btnBoothListEmail").style.color = config.DISABLED_GRAY;
		elemById( "btnBoothListEmail").setAttribute( "title", txt.TT_EMAIL_TAGGED_BOOTHS);
		if( !data.smallLayout) {
			btn.appendChild( elemById( "exhibitors"));

			elemById( "exhibitors").style.height = 0;
		}

		if( config.hasMultipleViews && config.hasFloorPlan) {
			data.filterExhibitorList = !config.initialAllExhibitors;
		}
	}
	
	function setupViewList( btn) {
		var group = elemById( "hallGroup");
		var bgColor = fxStyle.view.clrBg !== "" ? fxStyle.view.clrBg : fxStyle.mainHeader.clrBg;
		var bgGrad = fxStyle.view.gradBg !== "" ? fxStyle.view.gradBg : fxStyle.view.clrBg === "" ?
			fxStyle.mainHeader.gradBg : "";
		var txtColor = fxStyle.view.clrText !== "" ? fxStyle.view.clrText : fxStyle.mainHeader.clrText;
		
		data.arViews.forEach( function( view, index) {
			group.appendChild( elem.makeViewThumb( view, index, bgColor, bgGrad, txtColor));
		});	
		
		if( !data.smallLayout) {
			if( config.hasFloorPlan) {
				btn.appendChild( elemById( "views"));
				elemById( "views").style.height = 0;
			}
			else {
				elemById( "views").className = "carousel-left";
			}
		}
	}
	
	function addNavButtons() {
		var btn = elem.makeButton( "btnEx", txt.EXHIBITOR_LIST, fxStyle.exhibitor, fxStyle.mainHeader);
		navList.appendChild( btn);
		
		setupExhibitorListHeader( btn);
		
		if( data.smallLayout && config.hasFloorPlan) {
			navList.appendChild( elem.makeButton( "btnFp", txt.FLOOR_PLAN, fxStyle.floorplan, 
														fxStyle.mainHeader));
		}
		
		if( config.hasMultipleViews && config.salesMode !== "exhibitor") {
            if( data.smallLayout || config.hasFloorPlan) {
                btn = elem.makeButton( "btnVi", txt.VIEW_LIST, fxStyle.view, fxStyle.mainHeader);
                navList.appendChild( btn);
            }
			
			setupViewList( btn);
		}
		
		if( !config.bHideAvailableList && !( config.hasMultipleViews && !config.hasFloorPlan) ) {
			navList.appendChild( elem.makeButton( "btnAv", txt.AVAILABLE_LIST, fxStyle.availableBooth, 
														fxStyle.mainHeader));
		}
		if( config.bCategoryData) {
			navList.appendChild( elem.makeButton( "btnCa", txt.CATEGORY_LIST, fxStyle.category, 
														fxStyle.mainHeader));
		}
		if( config.bPavilionData) {
			navList.appendChild( elem.makeButton( "btnPa", txt.PAVILION_LIST, fxStyle.pavilion, 
														fxStyle.mainHeader));
		}
		if( config.bSubShowData) {
			navList.appendChild( elem.makeButton( "btnSs", txt.SHOW_IN_SHOW_LIST, fxStyle.subShow, 
														fxStyle.mainHeader));
		}
		if( config.bCountryData && !config.bHideCountryList) {
			navList.appendChild( elem.makeButton( "btnCo", txt.COUNTRY_LIST, fxStyle.country, 
														fxStyle.mainHeader));
		}
		
		if( data.smallLayout) {
			elemById( "menu").appendChild( navList);
		}
		else {
			elemById("listWindow").appendChild( navList);     // accordion
		}
	}
	
	function addOperations() {
		var menu = elemById( "menu");
		menu.style.backgroundColor = fxStyle.rows.clrEvenBg;
		menu.style.color = fxStyle.rows.clrEvenText;
		var ops = doc.createElement( "ul");
		ops.textContent = txt.FLOOR_PLAN_OPTIONS;
        if( config.hasFloorPlan) {
            if( config.bIAmHere) {   //  && data.device === "other"
				
				var iahMenuLabel = txt.I_AM_HERE;
				var iahToolTip = txt.TT_I_AM_HERE;
			
				if( config.elvis == true){
					iahMenuLabel = "E L I™";
					iahToolTip = "Send a location"
				}
				
				if	(config.elvis && data.queryCoord !== ""){
					//config.elvis = false; // URL intended for responder, no pass, remove ELI functionality
				}
				else{
					ops.appendChild( elem.makeListItem( "iah", iahMenuLabel, iahToolTip));
				}

				if  (config.wayCoords) {
					//TODO: Wayfinding function!
					//ops.appendChild( elem.makeListItem( "wayfind", "Wayfinder" ));
				}
				
            }

            if( config.bPDF && config.bFloorPlanPrint) {
                ops.appendChild( elem.makeListItem( "pdf", txt.PRINTABLE_PDF, txt.TT_OPEN_PDF, null));
            }

            if( config.bFloorPlanPrint) {
                ops.appendChild( elem.makeListItem( "prtFp", txt.PRINT_FLOORPLAN));
                ops.appendChild( elem.makeListItem( "prtWin", txt.PRINT_WINDOW));
            }
			
			menu.appendChild( ops);
		}
	}
	
    function addMenuItems() {
        var menu = elemById( "menu");
		var item = null;
		var ops = doc.createElement( "ul");
		ops.textContent = txt.MENU_VIEW;
		
        if( config.hasFloorPlan) {
			if( !config.bUnitsButton) {
				elemById( "btnUnits").style.display = "none";
			}
			else {
				ops.appendChild( elemById( "btnUnits"));
			}
			
            if( config.bLegend) {
                if( data.smallLayout || !config.legendOpen) {
                    ops.appendChild( elem.makeListItem( "btnLegend", txt.LEGEND));
                }
                else {
                    ops.appendChild( elem.makeListItem( "btnLegend", txt.LEGEND, "", "icon-check"));
                }
            }
            
            if( config.bBuilding) {
                ops.appendChild( elem.makeListItem( "build", txt.BUILDING, "", "icon-check"));
            }
			
            if( config.bMiniMap && !data.smallLayout) {
                if( config.bMiniMapOpen) {
                    ops.appendChild( elem.makeListItem( "map", txt.MINI_MAP, "", " icon-check"));
                }
                else {
                    ops.appendChild( elem.makeListItem( "map", txt.MINI_MAP));
                }
			}
			//Toggling the Minimap's 'X' button to also toggle 'icon-check' on menu
			if(!data.smallLayout && document.body.contains(document.getElementById("minimap"))){
				document.getElementById("minimap").querySelector(".closeBtn").addEventListener("click", function(){
					var mapItem = document.getElementById("map");
					mapItem.classList.remove("icon-check")
				})
				document.getElementById("minimap").querySelector(".Xtop").addEventListener("click", function(){
					var mapItem = document.getElementById("map");
					mapItem.classList.remove("icon-check")
				})
			} 
			if(!config.bToolbar && config.is3d || data.smallLayout && config.is3d){
				//if(data.smallLayout ) {
					if( config.openIn3D) {
						ops.appendChild( elem.makeListItem( "show3d", txt.SMALL_SHOW_3D, "", "icon-check"));
					}
					else {
						ops.appendChild( elem.makeListItem( "show3d", txt.SMALL_SHOW_3D));
					}
				//}
			}
            if( config.bDimensions) {
				if( config.is3d && config.openIn3D) {
					item = elem.makeListItem("bthDimensions", txt.MENU_DIMENSIONS);
					util.addClass( item, "disabled");
				}
				else {
					if( config.showDimensions){
						item = elem.makeListItem("bthDimensions", txt.MENU_DIMENSIONS, "", "icon-check");
					}
					else {
						item = elem.makeListItem("bthDimensions", txt.MENU_DIMENSIONS);
					}
				}
                ops.appendChild( item);
            }
			menu.appendChild( ops);
			//  placeholder for technical layer controls( if needed) to keep them with View
			ops = doc.createElement( "ul");
			ops.setAttribute( "id", "techLayersMenu");
			ops.style.display = "none";
			menu.appendChild( ops);
//            menu.appendChild( elem.makeListItem( "shCoords", txt.SHOW_COORDS));
        }
///////////////   end of view controls   ///////////////////////
        
		if( config.languages.length > 1) {
			setupLanguageSelection( menu);
		}
		
        if( config.bListPrint) {
            menu.appendChild( elem.makeListItem( "prtList", txt.TT_PRINT_LIST));
            util.addClass( elemById( "prtList"), "disabled");
        }
        menu.appendChild( elem.makeListItem( "help", txt.VIEW_HELP));
    }
	
	function floorPlanReadyHandler() {
		doc.removeEventListener( "Floor_Plan_Ready", floorPlanReadyHandler);
		util.addClass( elemById( "listWindow"), "nav-closed");
		util.addClass( elemById( "btnListHide"), "closed");
	}
	
    function initializePages() {
        var i = 3;
        var style = doc.createElement( "style");
		var sheet = null;
		var rule = "";
		

		if( data.smallLayout) {
			// add text before appending children!
			navList.textContent = txt.NAVIGATION;
			navList.setAttribute( "id", "menuNavigation");
		}
		
		var clrMainBg = fxStyle.mainHeader.clrBg;
        var clrMainText = fxStyle.mainHeader.clrText;
		
        if( config.showLists) {
			addNavButtons();
			
			if( !data.smallLayout) {
				elemById( "listWindow").style.backgroundColor = clrMainBg;
				elemById( "listWindow").style.color = clrMainText;
				elemById( "listWindow").style.display = "block";
				elemById( "btnListHide").style.backgroundColor = elemById( "btnMenu").style.backgroundColor;
				elemById( "btnListHide").style.color = elemById( "btnMenu").style.color;
				elemById( "listWindow").appendChild( navList);     // accordion
				
				data.initialAccordionHeight = elemById("listWindow").offsetHeight;
			}
        }

		addOperations();
		
        if( config.hasMultipleViews && !config.hasFloorPlan) {
                elemById( "floorplan").style.display = "none";
				elemById( "btnUnits").style.display = "none";
                data.filterExhibitorList = false;       // never filter
                
                if( !data.smallLayout) {
                    elemById( "vt").textContent = txt.VIEW_LIST;
                }
        }
        
        if( config.hasFloorPlan) {
            if( !data.smallLayout) {
                if( config.bMiniMap && !data.smallLayout) {
                    setupMiniMap();
                }
            }     
            
            if( config.bToolbar) {
                setupFloorPlanToolbar();
            }
			
            if( !data.smallLayout && config.viewName !== "" && config.showLists) {
                elemById( "btnListHide").style.display = "block";
				
                elemById( "btnListHide").addEventListener( "click", function() {
					util.toggleClass( elemById( "btnListHide"), "closed");
                    util.toggleClass( elemById( "listWindow"), "nav-closed");
                });
            }
            else {
                elemById( "btnListHide").style.display = "none";
            }
			if(elemById( "listWindow"), "nav-closed"){
				elemById( "btnListHide").addEventListener( "click", function() {
                    util.toggleClass( elemById( "listWindow"), "nav-open");
                });
			}
			if( !config.defaultListWindowOpen) {
				doc.addEventListener( "Floor_Plan_Ready", floorPlanReadyHandler);
			}
        }
		
        addMenuItems();
		
	///////////////////   ADD STYLE SHEET   /////////////////////////////////////////////////
		doc.head.appendChild(style);
		sheet = style.sheet;
        
        if( config.hasFloorPlan && config.bUnitsButton) {
                // always needed to set text in slide button
            sheet.insertRule( '#btnUnits .slideswitch_inner:before { content: "M"}', 0);
            sheet.insertRule( '#btnUnits .slideswitch_inner:after { content: "Ft"}', 0);
            sheet.insertRule( '#btnUnits .slideswitch_inner { color:' + "white" + '}', 0);

            var sldBut = elemById( "btnUnits").getElementsByTagName("button")[0];
            sldBut.style.backgroundColor = clrMainBg;
            sldBut.style.color = clrMainText;
            if( config.units === "M") {
                util.addClass( elemById( "btnUnits"), "on");
            }
        }
        if( fxStyle.rows.clrOddBg !== "") {
            sheet.insertRule( '.odd { background-color:' + fxStyle.rows.clrOddBg + '}', 0);
        }
        if( fxStyle.rows.clrEvenBg !== "") {
            sheet.insertRule( '.even { background-color:' + fxStyle.rows.clrEvenBg + '}', 0);
        }
        
        if( fxStyle.rows.clrOddText !== "") {
            sheet.insertRule( '.odd { color:' + fxStyle.rows.clrOddText + '}', 0);
        }
        if( fxStyle.rows.clrEvenText !== "") {
            sheet.insertRule( '.even { color:' + fxStyle.rows.clrEvenText + '}', 0);
        }
        
        sheet.insertRule( '.icon-star-filled:before { color:' + config.clrHighlight + '}', 0);
		
			//  for Premium or Featured exhibitors
		if( data.premiumLevels.length > 0) {
			data.premiumLevels.sort( comparer( "level", true));
			
			for( i = 0; i < data.premiumLevels.length; i++) {
				rule = ".p" + data.premiumLevels[i].level + "{background-color:" +
								data.premiumLevels[i].clrBackground + ";color:" +
								data.premiumLevels[i].clrText + ";}";
				
				sheet.insertRule( rule, 0);
				
				rule = ".icon-premium" + data.premiumLevels[i].level + ":after{content:'\\" +
								data.premiumLevels[i].iconCode + "';cursor:pointer;}";
				
				sheet.insertRule( rule, 0);
			}
		}
		
	///////////////////////////   SET TEXT   //////////////////////////////////////////////
        if(config.isXML){
			elemById( "expolink").textContent = "EXPOCAD® FX";
		}
		else{
			elemById( "expolink").textContent = "3e powered by EXPOCAD®";
			elemById( "expolink").style.color = fxStyle.footer.clrText;
		}
        elemById( "txtCr").textContent = txt.COPYRIGHT;
        elemById( "txtVer").textContent = txt.VERSION + data.version;
        elemById( "menuLabel").textContent = txt.MENU;
        elemById( "unitsLabel").textContent = txt.UNITS;
        elemById( "exhibitorSearch").setAttribute( "placeholder", txt.SEARCH_PROMPT);
        
        if( !config.bHideFloorPlanDate) {
            elemById( "dftnt").textContent = txt.CURRENT + config.lastSaved;
		}
		
		if(config.salesMode !== "none"){
			elemById( "dftnt").textContent = "LIVE";
		}
    }
    
	
    function removeAvailableBoothButton() {
        var btn = elemById( "btnAv");
        if( btn) {
            navList.removeChild( btn);
        }
    }
	
	function addTechMenu( isTwoD) {
		var menuGroup = elemById( "techLayersMenu");
		var item = null;
		var makeVisible = false;
		
		menuGroup.textContent = txt.MENU_TECH_LAYERS;
		
		data.arTechLayers.forEach( function( group) {
			if( group.graphics.length > 0 || group.txt.length > 0) {
				
				if( group.visible){
					item = elem.makeListItem( "layer " + group.id, group.name, "", "icon-check");
				}
				else{
					item = elem.makeListItem( "layer " + group.id, group.name, "");
				}
				
				menuGroup.appendChild( item);
				if( !isTwoD) {
					util.addClass( item, "disabled");
				}
				data.arLayersMenuItems.push( item);
				makeVisible = true;
			}
		});
		
		if( makeVisible) {
			menuGroup.style.display = "block";
		}
	}
    
		//  only affects mini map and sales window
    function resizeHandler() {
        if( data.miniMap) {
            if( !data.userMovedMap) {
                data.miniMap.window.style.top = elemById("appContent").clientHeight - 204 + "px";
                data.miniMap.window.style.left = elemById("appContent").clientWidth - 270 + "px";
            }
            else {
                if( data.miniMap.window.offsetTop + 204 > elemById("appContent").offsetHeight) {
                    data.miniMap.window.style.top = elemById("appContent").clientHeight - 204 + "px";
                }

                if( data.miniMap.window.offsetLeft + 270 > elemById("appContent").clientWidth) {
                    data.miniMap.window.style.left = elemById("appContent").clientWidth - 270 + "px";
                }
            }
		}
		if( data.salesWindow){
			if( !data.userMovedMapSales) {
                data.salesWindow.window.style.top = elemById("appContent").clientHeight - 680 + "px";
                data.salesWindow.window.style.left = elemById("appContent").clientWidth - 410 + "px";
            }
            else {
                if( data.salesWindow.window.offsetTop + 204 > elemById("appContent").offsetHeight) {
                    data.salesWindow.window.style.top = elemById("appContent").clientHeight - 1080 + "px";
                }

                if( data.salesWindow.window.offsetLeft + 410 > elemById("appContent").clientWidth) {
                    data.salesWindow.window.style.left = elemById("appContent").clientWidth - 470 + "px";
                }
            }
		}
    }
    
    
    return {
		addTechMenu: addTechMenu,
        initializePages: initializePages,
        removeAvailableBoothButton: removeAvailableBoothButton,
        resize: resizeHandler
    };
}());
    